// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PGgih","largestCol":"styles_largestCol__3NtQQ","smallestCol":"styles_smallestCol__3-Mfw"};